import React, { useEffect, useState, useRef } from 'react'
import WidgetHeader from '../../../../components/Widget/Header';
import { FormattedDate, FormattedTime } from 'react-intl'

const OrderListWidget = ({widget}) => {
  const mounted = useRef(false);
  
  const [orders, setOrders] = useState([]);
  const [title, setTitle] = useState('');

  useEffect(() => {
    mounted.current = true;
    fetch(`coordinatordashboard/${widget.widgetId}`)
    .then((response) => response.json())
    .then((data) => {
      if (mounted.current) {
        setOrders(data.data.orders);
      }
    });

    setTitle(widget.widgetId.replace(/_/g, ' '));

    return () => {
      mounted.current = false;
    };
  }, [])

  const getDeadline = (order) => {
    const value = new Date(order["deadline"] * 1000)
    return <div>
      <span className="mr-1">
        <FormattedDate value={value} />
      </span>
      <span>
        <FormattedTime value={value} />
      </span>
    </div>
  };

  const orderDetails = (uid) => {
    reactHistory.push(`/orders/${uid}`)
  };

  const getDeadlineStatus = (order) => {
    const diff = order['deadline'] - Math.floor(Date.now() / 1000);
    if(diff > 86400) {
      return <i className="block rounded-full w-2 h-2 bg-green-500" title="Deadline is not within the next 24 hours"></i>
    } else if (diff > 0) {
      return <i className="block rounded-full w-2 h-2 bg-yellow-500" title="Deadline is close!"></i>
    } else {
      return <i className="block rounded-full w-2 h-2 bg-red-600" title="Deadline has passed"></i>
    }
  }
  
  const widget_id = `ID_${widget.widgetId}`;
  return (
    <li className="bg-white border m-4 shadow rounded border-gray-400" key={widget_id} id={widget_id}>
      <WidgetHeader widget={widget} widgetTitle={title} />

      <div className="w-full text-xs">
        {orders.map((order) => (
          <div
            key={order.uid}
            className={`hover:bg-gray-200 flex border-b ${order['highlight'] ?? false ? 'bg-yellow-100' : ''}`}
            onClick={() => orderDetails(order['uid'])}
            title={order['comments']}
          >
            <div className="shrink-0 px-4 py-2 w-16">
              {order['deal_id'] ?
                <a
                  href={`https://my.voicearchive.com/crm/deal/details/${order['deal_id']}/`}
                  target="_blank"
                  className="mr-1"
                  onClick={(e) => e.stopPropagation()}
                >
                  D{order['deal_id']}
                </a>
                :
                order['uid']
              }
            </div>
            <div className="grow px-4 py-2 cursor-pointer hover:text-primary truncate">
                {order['name']}
            </div>
            <div className="shrink-0 px-4 py-2 flex justify-between items-center space-x-4">
                <span>{getDeadline(order)}</span>
                <span className="w-1 inline-block ml-2 mr-1">
                    {order['comments'] ? <i className="text-yellow-500 fa fa-info"></i> : ''}
                </span>
                <span className="text-xs w-2 inline-block mr-1">
                    {getDeadlineStatus(order)}
                </span>
            </div>
          </div>
        ))}
      </div>
    </li>
  );

}

export default OrderListWidget;
